import { formatISO } from "date-fns";

const formatISODate = (date: Parameters<typeof formatISO>[0]) =>
  formatISO(date, { representation: "date" });
export default formatISODate;
